import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegmentationForm, useSegmentationFormActions } from '../_form/SegmentationFormHandler'
import FlexGrid, { FlexCol } from '../../../../components/structure/FlexGrid'
import FormItem from '../../../../components/form/FormItem'

export const useGeneralStepDef = () => {
  const { t } = useTranslation('editSegmentation')
  const form = useSegmentationForm()

  return useMemo(
    () => ({
      title: t('generalStep.title'),
      subtitle: t('generalStep.subtitle'),
      Component: GeneralStep,
      validate: () => {
        if (!form.name) return [false, t('generalStep.nameRequired')]
        return [true]
      }
    }),
    [form.name, t]
  )
}

const GeneralStep = () => {
  const { t } = useTranslation('editSegmentation')
  const form = useSegmentationForm()
  const { handleChange } = useSegmentationFormActions()

  const commonProps = { handleChange, form, t }

  return (
    <div>
      <FlexGrid paddingGutter={0.5} align="flex-start" justify="flex-start" wrap>
        <FlexCol width="100%">
          <FormItem label={t('generalStep.name')} field="name" {...commonProps} />
        </FlexCol>
      </FlexGrid>
    </div>
  )
}

export default GeneralStep
